import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9011/api'

export const getSchema = (projectVersionId) => {
  const url = `${API_ROOT}/approver/${projectVersionId}/review/get`
  return doGet(url)
}

export const saveApproveProject = (request, projectVersionId) => {
  const url = `${API_ROOT}/approver/${projectVersionId}/submit/proposal`
  return doPost(url, request)
}

export const saveSecureApprove = (request, projectVersionId) => {
  const url = `${API_ROOT}/approver/${projectVersionId}/secure-approve`
  return doPost(url, request)
}

export const responseProjectApprove = (referenceID) => {
  const url = `${API_ROOT}/approver/${referenceID}/secure-approve`
  return doGet(url)
}

export const downloadRequestApproveFile = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/requestapprove/form`
  return doDownload(url)
}

//-----------ปุ่มกดดูสายอนุมัติใหม่-------------
export const getCheckApprover = (
  projectVersionId,
  approveType,
  changeType,
  workPlanCode,
  budget
) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/${approveType}/approver/check?changeType=${
    changeType || ''
  }&workPlanCode=${workPlanCode || ''}&budget=${budget || 0}`
  return doGet(url)
}

//----ตรวจสอบการอนุมัติ-----
export const getCheckApproverList = (pageSize, pageNumber, request) => {
  const url = `${API_ROOT}/approval/${pageSize || 0}/${pageNumber || 0}/approval/check`
  return doPost(url, request)
}

//-----ส่งอีเมล์------
export const getSendMailApprover = (projectVersionId, mailType, approveType, requestId) => {
  const url = `${API_ROOT}/approval/send-mail/${projectVersionId}/${mailType}/${approveType}?requestId=${
    requestId || ''
  }`
  return doGet(url)
}

//-----------ปุ่มกดดูยกเลิกสายอนุมัติใหม่-------------
export const getCheckCancelApprover = (projectVersionId, approveType, requestId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/${approveType}/approver/cancel?requestId=${
    requestId || ''
  }`
  return doGet(url)
}

//-----ส่งยกเลิกสายอนุมัติ------
export const getSubmitCancelApprover = (projectVersionId, approveType, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/${approveType}/approver/cancel`
  return doPost(url, request)
}

//-----ส่งขอสายใหม่------
export const getFetchNew = (projectVersionId, approveType, requestId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/${approveType}/approver/fetch-new?requestId=${
    requestId || ''
  }`
  return doPost(url)
}

//-----------ปุ่มกดดูวันลา-------------
export const getCheckLeavedate = (employeeCode) => {
  const url = `${API_ROOT}/approval/approver/leavedate/${employeeCode}`
  return doGet(url)
}
